module.exports = __webpack_public_path__ + "media/reskin-images/img--access-non-profit-702080a1.jpg";